// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__12Dlt","title":"Images45_title__15_9k","images":"Images45_images__18pox"};